import React from "react";
import type { BaseProvinceIconProps } from "./BaseProvinceIcon";

export const NovaScotiaIcon = (props: BaseProvinceIconProps) => {
  return (
    <g
      id="NS"
      {...props}
    >
      <path
        d="M339.1,219.8c0.3,0,0.5,0.2,0.6,0.4l1.6,4.8c0.1,0.2,0.3,0.4,0.6,0.4h0.1l2.4-0.5h0.1c0.1,0,0.2,0,0.3,0.1
            l1.9,1.1c0.3,0.1,0.4,0.5,0.3,0.7l-2.1,5.8c-0.1,0.2-0.3,0.4-0.5,0.4h-1c-0.2,0-0.4,0.1-0.5,0.3l-0.7,1.3c-0.1,0.2-0.3,0.3-0.5,0.3
            c-0.1,0-0.2,0-0.3-0.1l-2-1c-0.1-0.1-0.2-0.1-0.2-0.2l-1.8-2.6c-0.1-0.1-0.1-0.3-0.1-0.4l0.4-2.9v-0.1l-0.7-6.8
            c0-0.3,0.2-0.6,0.5-0.6C338,220.1,338.7,219.9,339.1,219.8C339,219.8,339.1,219.8,339.1,219.8L339.1,219.8z"
      />
      <path
        d="M335.4,233.9c0.1,0,0.1,0,0.2,0l5.7,1.1c0.3,0.1,0.6,0.3,0.7,0.6l0.2,0.8c0,0.1,0,0.3,0,0.5
            c-0.3,1.2-0.6,1.9-0.7,2.1c0,0.1-0.1,0.2-0.2,0.3l-2.2,2.3l-0.1,0.1l-6.9,9.6l-0.1,0.1l-4.1,4.1c-0.1,0.1-0.2,0.2-0.2,0.4
            c-0.5,1.5-0.9,3-1.4,4.5c-0.4,1.3-0.8,2.6-1.1,3.9c-0.1,0.6-0.3,1.3-1,1.3c-0.1,0-0.2,0-0.4,0c-1.5,0-3.1-0.5-4.5-0.8
            c-0.4-0.1-0.7-0.4-0.7-0.8l-0.5-8.3c0-0.2,0-0.4,0.2-0.6c0.5-0.5,10.4-9.9,8.6-9.9c-0.4,0-3.8-0.2-3.9-0.2c-0.6,0-1-0.6-0.8-1.2
            l1.4-3.7c0.1-0.3,0.3-0.5,0.6-0.5l7-1.6h0.2l1.6,0.1c0.5,0,0.9-0.4,0.9-0.9l-0.1-1.8c0-0.2,0.1-0.4,0.2-0.6l0.6-0.7
            C334.9,233.9,335.1,233.8,335.4,233.9L335.4,233.9z"
      />
    </g>
  );
};
